import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { axiosGet } from "../utils/axios";

export default function CrediColaReport() {
  const [reportUrl, setReportUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [debugInfo, setDebugInfo] = useState("");

  useEffect(() => {
    let isMounted = true;
    const endpoint = `${process.env.REACT_APP_DIST_URL}/admin-reports/credi-cola-report/fileurl`;

    const loadReportUrl = async () => {
      try {
        setIsLoading(true);
        setErrorMessage("");
        setDebugInfo("");

        const response = await axiosGet(endpoint);
        const payload = response?.data || {};
        const nextUrl =
          payload?.preSignedUrl ||
          payload?.presignedUrl ||
          payload?.url ||
          payload?.fileUrl ||
          payload?.pre_signed_url ||
          payload?.data?.preSignedUrl ||
          payload?.data?.url ||
          "";

        if (!nextUrl) {
          const responseKeys = Object.keys(payload);
          throw new Error(
            `Report URL not returned by API. Endpoint: ${endpoint}. Response keys: ${responseKeys.join(", ") || "none"}`,
          );
        }

        if (isMounted) {
          setReportUrl(nextUrl);
          setDebugInfo(`Fetched report URL from endpoint: ${endpoint}`);
        }
      } catch (error) {
        if (isMounted) {
          const status = error?.response?.status || error?.status;
          const details = error?.message || "Unknown error";
          setErrorMessage("Unable to load Credi-Cola report.");
          setDebugInfo(`Endpoint: ${endpoint}. Status: ${status || "n/a"}. Details: ${details}`);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadReportUrl();

    return () => {
      isMounted = false;
    };
  }, []);

  if (isLoading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading Credi-Cola report...</Typography>
      </Box>
    );
  }

  if (errorMessage) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">{errorMessage}</Typography>
        <Typography sx={{ mt: 1, wordBreak: "break-word" }} variant="body2">
          {debugInfo}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <iframe
        title="Credi-Cola Report"
        src={reportUrl}
        style={{ width: "100%", height: "calc(100vh - 120px)", border: 0 }}
        onError={() => {
          setErrorMessage("Unable to render Credi-Cola report iframe.");
          setDebugInfo(`Iframe source failed to load. URL: ${reportUrl}`);
        }}
      />
    </Box>
  );
}
